import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class HttpCancelService {
	private pendingHTTPRequests$ = new Subject<void>();
	private nonCancellableRequests$ = new Subject<void>();

	// URLs that should NOT be cancelled on route change (critical cache/setup endpoints)
	private readonly NON_CANCELLABLE_URLS = [
		'loginSetup',
		'user_carrier_map',
		'admin/account/users',
		'notificationSettings',
		'integrationTypes',
		'bookingAutomationConfiguration',
	];

	constructor() {}

	public cancelPendingRequests() {
		this.pendingHTTPRequests$.next();
	}

	public onCancelPendingRequests(req: any) {
		const isNonCancellable = this.NON_CANCELLABLE_URLS.some((url) => req.url.indexOf(url) !== -1);
		if (isNonCancellable) {
			return this.nonCancellableRequests$.asObservable();
		}
		return this.pendingHTTPRequests$.asObservable();
	}
}
